import { render, staticRenderFns } from "./awakening.vue?vue&type=template&id=1e5e791e&scoped=true"
import script from "./awakening.vue?vue&type=script&lang=js"
export * from "./awakening.vue?vue&type=script&lang=js"
import style0 from "./awakening.vue?vue&type=style&index=0&id=1e5e791e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5e791e",
  null
  
)

export default component.exports